export default "__VITE_ASSET__W_Ai7TwF__";